import { Partial } from '@40seas/entities/common';
import { FeatureToggle } from './feature-toggle.entity';

export class UpdateFeatureToggleDto extends Partial(FeatureToggle) {}
